import {
  backgroundVariants,
  borderVariants,
  classNames,
  tv,
} from "@opensea/ui-kit"

export const itemVariants = tv({
  base: "h-17 rounded-md bg-bg-primary px-4 py-1.5",
  variants: {
    interactive: {
      true: classNames(
        backgroundVariants({ background: "primary", interactive: true }),
        borderVariants({ border: "border-1", interactive: true }),
      ),
      false: classNames(
        backgroundVariants({ background: "primary", interactive: false }),
        borderVariants({ border: "border-1", interactive: false }),
      ),
    },
  },
  defaultVariants: {
    interactive: true,
  },
})
